class EditorialProductCard extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.image = this.querySelector('[data-card-image]');
    this.pill = this.querySelector('[data-card-pill]');
    this.meta = this.querySelector('[data-card-meta]');
    this.price = this.querySelector('[data-card-price]');
    this.links = this.querySelectorAll('[data-card-link]');
    this.swatches = this.querySelectorAll('[data-card-swatch]');
    this.videoButton = this.querySelector('[data-card-video-open]');

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => this.selectSwatch(swatch));
    });

    let preloadTimer = null;
    this.addEventListener(
      'pointerenter',
      () => {
        preloadTimer = setTimeout(() => this.preloadSwatchImages(), 140);
      },
      { passive: true }
    );
    this.addEventListener('pointerleave', () => clearTimeout(preloadTimer), { passive: true });
    ['touchstart', 'focusin'].forEach((event) =>
      this.addEventListener(event, () => this.preloadSwatchImages(), { once: true, passive: true })
    );
  }

  preloadSwatchImages() {
    if (this.preloaded) return;
    this.preloaded = true;

    this.swatches.forEach((swatch) => {
      const { src, srcset } = swatch.dataset;
      if (!src) return;
      const image = new Image();
      image.decoding = 'async';
      if (srcset) image.srcset = srcset;
      image.src = src;
    });
  }

  selectSwatch(swatch) {
    this.swatches.forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const { src, srcset, alt, swatch: swatchValue, swatchFocal, subtitle, price, href } = swatch.dataset;

    if (this.image && src) {
      this.image.src = src;
      if (srcset) this.image.srcset = srcset;
      if (alt) this.image.alt = alt;
    }

    if (this.pill && swatchValue) {
      this.pill.hidden = false;
      this.pill.style.setProperty('--card-product-editorial-swatch', swatchValue);
      if (swatchFocal) {
        this.pill.style.setProperty('--card-product-editorial-swatch-focal', swatchFocal);
      } else {
        this.pill.style.removeProperty('--card-product-editorial-swatch-focal');
      }
    }

    if (this.meta && subtitle) this.meta.textContent = subtitle;
    if (this.price && price) this.price.textContent = price;
    if (href) this.links.forEach((link) => link.setAttribute('href', href));
    this.applyVideo(swatch);
  }

  applyVideo(swatch) {
    if (!this.videoButton) return;

    const src = swatch.dataset.videoSrc;
    if (!src) {
      this.videoButton.hidden = true;
      this.videoButton.removeAttribute('data-video-src');
      return;
    }

    this.videoButton.hidden = false;
    this.videoButton.dataset.videoKind = swatch.dataset.videoKind || 'file';
    this.videoButton.dataset.videoSrc = src;
    if (swatch.dataset.videoPoster) {
      this.videoButton.dataset.videoPoster = swatch.dataset.videoPoster;
    } else {
      delete this.videoButton.dataset.videoPoster;
    }
  }
}

if (!customElements.get('editorial-product-card')) {
  customElements.define('editorial-product-card', EditorialProductCard);
}
